import React, { useState } from 'react'

const BasicAuth1 = ({children}) => {

    const [loggedIn, setLoggedIn] = useState(false)

    if (loggedIn) {
        return (<>{children}</>)
    }
  return (
    <>
    
        <div className="bg-white fixed h-screen w-screen top-0 left-0 flex items-center justify-center">

            <div className="w-full max-w-sm mx-auto overflow-hidden bg-white md:border border-gray-200 md:rounded-xl">
                <div className="px-11 py-8">
                    <div className="flex justify-center mx-auto">
                        Calci | AM
                    </div>

                    <h3 className="mt-3 text-xl font-medium text-center text-gray-600">Welcome Back</h3>

                    <p className="mt-1 text-center text-gray-500">Login to Calci account</p>

                    <div>
                        <div className="w-full mt-4">
                            <input className="block w-full px-4 py-2 mt-2 text-gray-700 placeholder-gray-500 bg-white border rounded-lg dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300" type="email" placeholder="Email Address" aria-label="Email Address" />
                        </div>

                        <div className="w-full mt-4">
                            <input className="block w-full px-4 py-2 mt-2 text-gray-700 placeholder-gray-500 bg-white border rounded-lg dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300" type="password" placeholder="Password" aria-label="Password" />
                        </div>

                        <div className="flex items-center justify-between mt-4">
                            <a href="https://www.stalicon.com/" className="text-sm text-gray-600 dark:text-gray-200 hover:text-gray-500">Powered by Stalicon</a>

                            <button onClick={() => setLoggedIn(true)} className="px-6 py-2 text-sm font-medium tracking-wide text-gray-500 capitalize border border-gray-200 duration-300 rounded-lg">
                                Sign In
                            </button>
                        </div>
                    </div>
                </div>

                <div className="flex items-center justify-center py-4 text-center bg-gray-50 dark:bg-gray-700">
                    <span className="text-sm text-gray-600 dark:text-gray-200">This app is currently only for Calci | AM team, contact support if you're unable to access</span>
                </div>
            </div>

        </div>
    
    </>
  )
}

export default BasicAuth1